import { useSelector } from "react-redux";
import PlayersInGame from "../../../../common/components/PlayersInGame";
import {
    ICharactersGroup,
    Localised,
    Lang,
    IInterestingDiscussionGameConfig,
    IPlayer,
    LocalStorage
} from "../../../../common/types";
import { getCurrentLang } from "../../../../common/utils/lang";
import { getPlayers } from "../../../../redux/playersSlice";
import { withTranslation } from 'react-i18next';
import React, {useMemo, useState} from "react";
import PlayScreen from "../../../../common/components/game-screens/PlayScreen";
import Button from "../../../../common/components/Button";
import T from "../../../../common/i18n/Text";
import {getNextRandomLocalisedAndSaveAsUsed} from "../../../../common/utils/storage";

const topicsData = require("../topics.json");
const charactersGroups = require("../characters.json");

interface Props {
    backToDetails: () => void;
    backToConfig: () => void;
    config: IInterestingDiscussionGameConfig;
}

const InterestingDiscussionGamePlay = ({ backToDetails, backToConfig, config }: Props) => {
    const players = useSelector(getPlayers);
    const activeLang: Lang = getCurrentLang();

    const allCharacters = useMemo(() => {
        const selectedCharactersGroups = charactersGroups.filter((group: ICharactersGroup, index: number) => config.selectedCharactersGroupIndexes.includes(index));
        return selectedCharactersGroups.flatMap((group: ICharactersGroup) => group.characters);
    }, [config.selectedCharactersGroupIndexes]);

    const getRandomCharactersSet = (size: number) :Localised<string>[] => {
        return [...Array(size)].map(() => (getNextRandomLocalisedAndSaveAsUsed(allCharacters, LocalStorage.USED_DISCUSSION_CHARACTERS_STORAGE)));
    };

    const [randomCharacters, changeRandomCharacters] = useState<Localised<string>[]>(getRandomCharactersSet(config.selectedPlayerIds.length));

    const playersWithCharacter = useMemo(() => {
        const playersInGame: IPlayer[] = players.filter(player => config.selectedPlayerIds.includes(player.id));

        if (randomCharacters.length !== playersInGame.length) return playersInGame;

        return playersInGame.map((player, index) => ({ ...player, name: randomCharacters[index][activeLang] }));
    }, [activeLang, randomCharacters, players, config.selectedPlayerIds]);

    const actionButton = <Button type="primary" name="change-professions"
                            onClick={() => changeRandomCharacters(getRandomCharactersSet(config.selectedPlayerIds.length))}>
                            <T path="games.interesting-discussion.button" />
                        </Button>;

    const theme = useMemo(() => {
        return config.randomTopic
            ? getNextRandomLocalisedAndSaveAsUsed(topicsData, LocalStorage.USED_DISCUSSION_TOPICS_STORAGE)
            : {ru: config.customTopic,  en: config.customTopic};
    }, [config.randomTopic, config.customTopic]);

    return (
        <PlayScreen mainActions={actionButton} showConfig={backToConfig} showInfo={backToDetails}>
            <div className="h-full grid grid-rows-[auto_1fr]">
                <h2 className="theme text-[#252429] text-[36px] text-center leading-[44px] font-bold mb-[40px]">
                    {theme[activeLang]}
                </h2>
                <PlayersInGame playersInGame={playersWithCharacter} />
            </div>
        </PlayScreen>
    );
};

export default withTranslation()(InterestingDiscussionGamePlay);
